import React , { useEffect, useRef } from "react";
import Select from "react-select";
import SelectedAttributeValues from "./SelectedAttributeValues";
import VariantMeta from "./VariantMeta";
import ReUse from "../../services/helpers/reUse";

const IndividualVariant = ({ inventoryVariantProps }) => {
  const {
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    generatedVariations,
    variantDataHandler,
    variantData,
    handlecolorsOptionAddition,
    colorssdsd,
    setAllCode
    // ggggg,
  } = inventoryVariantProps ?? {};


  const generateId = ReUse.makeId();

  // const inputRef = useRef([]);

  // useEffect(()=>{
  //   generatedVariations?.map((val,index)=>{
  //     inputRef.current.push(React.createRef());
  //   });
  // },[generatedVariations])


  return (
    <>
      <div className="col-md-12">
        <div className="all-select-dv">
          <div className="mcq-dv-all">
            <h5>Add Varaitions / Attribute</h5>
          </div>

          <Select
            isMulti
            name="attributes"
            options={extractAttributeOptions}
            classNamePrefix="select"
            // value={extractAttributeOptions?.find(
            // 	(option) => option?.value === selectedAttributes?.value,
            // )}
            value={selectedAttributes}
            onChange={(selectedOptions) =>
              setSelectedAttributes(selectedOptions)
            }
          />
        </div>
      </div>
      


      {selectedAttributes?.map((selectedAttribute, index) => (
        <SelectedAttributeValues
          attributeOptions={attributeOptions}
          delimiters={delimiters}
          handleAttributeOptionDelete={handleAttributeOptionDelete}
          handleAttributeOptionAddition={handleAttributeOptionAddition}
          handleAttributeOptionDrag={handleAttributeOptionDrag}
          handleAttributeOptionClick={handleAttributeOptionClick}
          selectedAttribute={selectedAttribute}
          currentIndex={index || 0}
          labelValue={selectedAttribute?.label}
          key={selectedAttribute?.value || index}
          colorssdsd={colorssdsd}
          setAllCode={setAllCode}
          value={selectedAttributes}
        />
      ))}

      {/* {generatedVariations?.length > 0 ? (
        <div className="col-md-12">
          <div className="mcq-dv-all">
            <h5>Variant, Price, and Stock</h5>
          </div>
          <div className="all-select-product-table">
            <table>
              <thead>
                <th>variant</th>
                <th>variant price</th>
                <th>discount price</th>
                <th>quantity</th>
                <th>SKU</th>
              </thead>
              <tbody>
                {generatedVariations?.map((variation, index) => {
                  return (
                    <VariantMeta
                      key={generateId}
                      variation={variation}
                      index={index}
                      variantDataHandler={variantDataHandler}
                      variantData={variantData}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : ( */}
        <div className="col-md-12">
          <div className="mcq-dv-all">
            <h5>Variant, Price, and Stock</h5>
          </div>
          <div className="all-select-product-table">
            <table>
              <thead>
                <th>variant</th>
                <th>variant price</th>
                <th>discount price</th>
                <th>quantity</th>
                <th>SKU</th>
              </thead>
              <tbody>
                {generatedVariations?.map((variation, index) => {
                  // console.log(variation,"sdisdoisde223344")
                  return (
                    <VariantMeta
                      key={index} //{generateId}
                      variation={variation}
                      index={index}
                      variantDataHandler={variantDataHandler}
                      variantData={variantData}
                      // inputRef={inputRef}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      {/* // )} */}
    </>
  );
};

export default IndividualVariant;
